import { Inject } from "inversify-props";
import type { AutenticacaoRemotaServiceAdapter } from "./adapter/AutenticacaoRemotaServiceAdapter";
import { AxiosRequestConfig } from "axios";
import { AutenticacaoRemotaDTO, StatusDaAutenticacaoRemota } from "@/models";

export class AutenticacaoRemotaUseCase {
	@Inject('AutenticacaoRemotaServiceAdapter')
	private autenticacaoRemotaServiceAdapter!: AutenticacaoRemotaServiceAdapter

	findAutenticacoesRemotas = async (params?: any, config?: AxiosRequestConfig) => 
		await this.autenticacaoRemotaServiceAdapter.findAutenticacoesRemotas(params, config)

	atualizarStatusDaAutenticacaoRemota = async (autenticacaoId: string, status: StatusDaAutenticacaoRemota) =>
		await this.autenticacaoRemotaServiceAdapter.atualizarStatusDaAutenticacaoRemota(autenticacaoId, status)

	criarAutenticacaoRemota = async (autenticacaoRemota: AutenticacaoRemotaDTO) =>
		await this.autenticacaoRemotaServiceAdapter.criarAutenticacaoRemota(autenticacaoRemota)

	findById = async (autenticacaoRemotaId: string) =>
		await this.autenticacaoRemotaServiceAdapter.findById(autenticacaoRemotaId)
}